import _ from 'lodash'
import moment from 'moment'

export const getFormattedDuration = (duration) => {
  const ts = moment.utc(duration * 1000)
  let formatted = `${ts.second()}s`
  if (ts.minute()) {
    formatted = `${ts.minute()}m ` + formatted 
  }
  if (ts.hour()) {
    formatted = `${ts.hour()}h ` + formatted 
  }

  return formatted
}

export const getImageDimensions = async (src) => {
  return new Promise((resolve, reject) => {
    const image = new Image()
    image.onload = () => {
      const dimensions = { width: image.naturalWidth, height: image.naturalHeight }
      resolve(dimensions)
    }
    image.onerror = reject
    image.src = src
  })
}

export const generateMetadata = async (file) => {
  // set file metadata
  const metadata = {
    id: file.id,
    size: _.get(file, 'human_size', 0),
    type: _.get(file, 'type', 'unknown'),
    mimeType: _.get(file, 'mime_type', 'unknown'),
    rawFilename: _.get(file, 'file_name'),
    createdAt: _.get(file, 'created_at'),
    updatedAt: _.get(file, 'updated_at'),
    uploadUser: _.get(file, 'upload_user.name'),
    url: _.get(file, 'url', ''),
    hasDimensions: false,
    dimensions: _.get(file, 'custom_properties.dimensions'),
    duration: Math.round(_.get(file, 'custom_properties.duration', 0)),
    optimized: _.get(file, 'custom_properties.optimized', false),
    processingStatus: _.get(file, 'custom_properties.processingStatus'),
    supportsCaptions: false,
    assigned: _.get(file, 'data_objects.length', 0),
    usage: _.get(file, 'usage', false),
    timestamp: _.get(file, 'timestamp', 0),
    loaded: !!file
  }

  // metadata.timestamp = moment(metadata.updatedAt).format('X')
  // metadata.dynamic_url = `${metadata.url}?t=${metadata.timestamp}`

  metadata.createdAtFormatted = moment(metadata.createdAt).format('LLL')
  metadata.updatedAtFormatted = moment(metadata.updatedAt).format('LLL')
  metadata.durationFormatted = getFormattedDuration(metadata.duration)

  // check for dimensions support
  metadata.hasDimensions = ['image'].indexOf(metadata.type) >= 0

  // check for duration support
  metadata.hasDuration = ['audio', 'video'].indexOf(metadata.type) >= 0

  // check for caption support
  if (['audio', 'video'].indexOf(metadata.type) >= 0) {
    metadata.supportsCaptions = true
    metadata.captions = _.get(file, 'custom_properties.captions[0]')
    metadata.captions_url = metadata.captions ? `/${file.disk}/${metadata.captions}` : null
  }

  // fallback for missing dimensions
  if (!_.size(metadata.dimensions) && metadata.type === 'image') {
    try {
      metadata.dimensions = await getImageDimensions(metadata.url)
    } catch (err) {
      console.error(err)
    }
  }

  return metadata
}